/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateOrUpdatePositionCommand } from '../models/create-or-update-position-command';
import { CreateOrUpdateWageCodeCommand } from '../models/create-or-update-wage-code-command';
import { ListPositionsQuery } from '../models/list-positions-query';
import { ListPositionsResult } from '../models/list-positions-result';
import { ListWageCodeQuery } from '../models/list-wage-code-query';
import { ListWageCodeResult } from '../models/list-wage-code-result';
import { RemovePositionCommand } from '../models/remove-position-command';
import { RemoveWageCodeCommand } from '../models/remove-wage-code-command';
import { SetPositionsOrderCommand } from '../models/set-positions-order-command';

@Injectable({
  providedIn: 'root',
})
export class WageCodeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation wageCodeList
   */
  static readonly WageCodeListPath = '/api/WageCode/List';

  /**
   * Bérkódok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeList$Plain$Response(params?: {
    body?: ListWageCodeQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListWageCodeResult>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListWageCodeResult>;
      })
    );
  }

  /**
   * Bérkódok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeList$Plain(params?: {
    body?: ListWageCodeQuery
  },
  context?: HttpContext

): Observable<ListWageCodeResult> {

    return this.wageCodeList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListWageCodeResult>) => r.body as ListWageCodeResult)
    );
  }

  /**
   * Bérkódok lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeList$Response(params?: {
    body?: ListWageCodeQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListWageCodeResult>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListWageCodeResult>;
      })
    );
  }

  /**
   * Bérkódok lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeList(params?: {
    body?: ListWageCodeQuery
  },
  context?: HttpContext

): Observable<ListWageCodeResult> {

    return this.wageCodeList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListWageCodeResult>) => r.body as ListWageCodeResult)
    );
  }

  /**
   * Path part for operation wageCodePost
   */
  static readonly WageCodePostPath = '/api/WageCode/Post/Post';

  /**
   * Bérkód létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodePost$Response(params?: {
    body?: CreateOrUpdateWageCodeCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Bérkód létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodePost(params?: {
    body?: CreateOrUpdateWageCodeCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.wageCodePost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation wageCodeRemove
   */
  static readonly WageCodeRemovePath = '/api/WageCode/Remove/Remove';

  /**
   * Bérkód törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeRemove()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeRemove$Response(params?: {
    body?: RemoveWageCodeCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeRemovePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Bérkód törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeRemove$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeRemove(params?: {
    body?: RemoveWageCodeCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.wageCodeRemove$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation wageCodeCsv
   */
  static readonly WageCodeCsvPath = '/api/WageCode/Csv';

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCodeCsv$Plain$Response(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeCsvPath, 'get');
    if (params) {
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCodeCsv$Plain(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.wageCodeCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCodeCsv$Response(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeCsvPath, 'get');
    if (params) {
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  wageCodeCsv(params?: {
    RequestUserId?: number;
    APIKey?: string;
    TranslationLanguageCode?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.wageCodeCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation wageCodeListPositions
   */
  static readonly WageCodeListPositionsPath = '/api/WageCode/ListPositions';

  /**
   * Pozíciók lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeListPositions$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeListPositions$Plain$Response(params?: {
    body?: ListPositionsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPositionsResult>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeListPositionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPositionsResult>;
      })
    );
  }

  /**
   * Pozíciók lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeListPositions$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeListPositions$Plain(params?: {
    body?: ListPositionsQuery
  },
  context?: HttpContext

): Observable<ListPositionsResult> {

    return this.wageCodeListPositions$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPositionsResult>) => r.body as ListPositionsResult)
    );
  }

  /**
   * Pozíciók lekérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeListPositions()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeListPositions$Response(params?: {
    body?: ListPositionsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPositionsResult>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeListPositionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPositionsResult>;
      })
    );
  }

  /**
   * Pozíciók lekérése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeListPositions$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeListPositions(params?: {
    body?: ListPositionsQuery
  },
  context?: HttpContext

): Observable<ListPositionsResult> {

    return this.wageCodeListPositions$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPositionsResult>) => r.body as ListPositionsResult)
    );
  }

  /**
   * Path part for operation wageCodePostPosition
   */
  static readonly WageCodePostPositionPath = '/api/WageCode/PostPosition/PostPosition';

  /**
   * Pozíció létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodePostPosition()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodePostPosition$Response(params?: {
    body?: CreateOrUpdatePositionCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodePostPositionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Pozíció létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodePostPosition$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodePostPosition(params?: {
    body?: CreateOrUpdatePositionCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.wageCodePostPosition$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation wageCodeRemovePosition
   */
  static readonly WageCodeRemovePositionPath = '/api/WageCode/RemovePosition/RemovePosition';

  /**
   * Pozíció törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeRemovePosition()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeRemovePosition$Response(params?: {
    body?: RemovePositionCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeRemovePositionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Pozíció törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeRemovePosition$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeRemovePosition(params?: {
    body?: RemovePositionCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.wageCodeRemovePosition$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation wageCodeSetPositionOrder
   */
  static readonly WageCodeSetPositionOrderPath = '/api/WageCode/SetPositionOrder/SetPositionOrder';

  /**
   * Pozíciók sorrendjének módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `wageCodeSetPositionOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeSetPositionOrder$Response(params?: {
    body?: SetPositionsOrderCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, WageCodeService.WageCodeSetPositionOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Pozíciók sorrendjének módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `wageCodeSetPositionOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  wageCodeSetPositionOrder(params?: {
    body?: SetPositionsOrderCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.wageCodeSetPositionOrder$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
